import React from 'react'

import { Account, SubscriptionType } from 'src/user/fragments'
import { Feature, Subscription } from 'src/dashboard/components'

import styles from '../../styles/account.module.scss'
import { useSubscriptions } from 'src/hooks/index'
import { Button } from '@sendoutcards/quantum-design-ui'

type SubscriptionsProps = {
  account: Account
  changeSubscription: (subscription?: SubscriptionType) => void
  setIsConfirmDialogueOpen: (open: boolean) => void
  isChangingSubscription: boolean
}

const Subscriptions: React.FC<SubscriptionsProps> = props => {
  const {
    account,
    changeSubscription,
    isChangingSubscription,
    setIsConfirmDialogueOpen,
  } = props

  const { isInGreenerStillGracePeriod } = useSubscriptions()

  return (
    <div className={styles.accountActivePlan}>
      {account.subscriptions &&
        account.subscriptions.map((sub: SubscriptionType) => (
          <div
            key={sub.id}
            className={styles.subscription}
            style={{ padding: '15px 5px' }}
          >
            <Subscription
              subscription={sub}
              shouldShowDates={true}
              onChangeSubscription={() => changeSubscription(sub)}
              isChangingSubscription={isChangingSubscription}
            />
          </div>
        ))}
      {isInGreenerStillGracePeriod && (
        <div className={styles.subscription} style={{ padding: '15px 5px' }}>
          <Button
            type="secondary"
            fullWidth={true}
            title={'Renew your Affiliate subscription'}
            onClick={() => {
              setIsConfirmDialogueOpen && setIsConfirmDialogueOpen(true)
            }}
            disabled={isChangingSubscription}
          />
        </div>
      )}
      {account.addons && (
        <div
          key={'addons'}
          className={styles.subscription}
          style={{ padding: '15px 5px' }}
        >
          <Subscription
            subscription={account.addons}
            shouldShowDates={false}
            shouldShowPrice={false}
          />
        </div>
      )}
      {!!account.heartfeltSends && (
        <Feature
          feature={{
            label: 'Heartfelt Sends',
            remaining: account.heartfeltSends,
          }}
        />
      )}
      {!!account.systemSends && (
        <Feature
          feature={{
            label: 'Automated Sends',
            remaining: account.systemSends,
          }}
        />
      )}
    </div>
  )
}

export default Subscriptions
